import React from 'react';
import styles from './separator.css';

const Separator = () => <hr className={styles.separator} />;

export default Separator;
